/* eslint-disable react/jsx-props-no-spreading */
import { SVGProps } from 'react';

const LearnMoreIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="LearnMoreIcon">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0L14 0 14 14 0 14z" />
      <path
        fill="var(--brand-bg-primary)"
        fillRule="nonzero"
        d="M5.833 3.5v1.167H2.917v6.416h6.416V8.167H10.5v3.5c0 .322-.261.583-.583.583H2.333c-.322 0-.583-.261-.583-.583V4.083c0-.322.261-.583.583-.583h3.5zm6.417-1.75v4.667h-1.167V3.74L6.537 8.287l-.824-.824 4.545-4.546H7.583V1.75h4.667z"
      />
    </g>
  </svg>
);

export default LearnMoreIcon;
